import React from 'react';

function DarkFaqPlatform(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width={52}
      height={52}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={52} height={52} rx={4} fill='#5B316D' />
      <mask
        id='mask0_10148_43188'
        style={{
          maskType: 'alpha'
        }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={10}
        width={32}
        height={32}
      >
        <rect x={10} y={10} width={32} height={32} fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_10148_43188)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M26.8406 12.0112L28.9187 12.3157L28.9276 12.3168L28.9366 12.319C34.0995 13.4166 38.2795 17.4689 39.5649 22.5681L39.6798 23.0656L39.682 23.0745L39.6831 23.0835L39.9877 25.1627L39.991 25.1895L39.9899 25.2163C39.9794 25.4708 39.9866 25.7298 39.9932 26.0016C39.9998 26.2697 40.0058 26.55 39.9899 26.8282C39.2856 39.1215 23.9494 44.5857 15.6076 35.3884C7.73445 26.7055 13.5697 12.6738 25.1762 12.0078H26.8194L26.8406 12.0112ZM25.995 15.3275C20.1003 15.3277 15.3221 20.1081 15.322 26.0049C15.322 31.9018 20.1013 36.6821 25.9961 36.6824C31.8909 36.682 36.6691 31.9018 36.6691 26.0049L36.6546 25.4561C36.3689 19.8144 31.7058 15.3277 25.995 15.3275Z'
          fill='#C299C5'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M29.6908 29.666L18.4099 33.598L22.4346 22.3774L33.5816 18.4196L29.6908 29.666ZM25.9952 23.7684C24.7599 23.7684 23.7586 24.7706 23.7586 26.0072C23.7589 27.2435 24.76 28.2448 25.9952 28.2448C27.2302 28.2447 28.2304 27.2434 28.2306 26.0072C28.2306 24.7707 27.2304 23.7685 25.9952 23.7684Z'
          fill='#C299C5'
        />
      </g>
    </svg>
  );
}

DarkFaqPlatform.displayName = 'DarkFaqPlatform';

export default DarkFaqPlatform;
